import { Node, mergeAttributes } from '@tiptap/core';
const LIST_EXT_NAME = 'brandGuidelines';
const ITEM_EXT_NAME = 'brandGuidelinesLink';
export const BrandGuidelinesLink = Node.create({
    name: ITEM_EXT_NAME,
    group: LIST_EXT_NAME,
    content: 'text*',
    marks: '',
    isolating: true,
    draggable: true,
    addOptions() {
        return {
            tagName: 'mb-brand-guidelines-link',
        };
    },
    parseHTML() {
        return [
            {
                tag: this.options.tagName,
            },
        ];
    },
    renderHTML({ HTMLAttributes, node }) {
        return [
            this.options.tagName,
            mergeAttributes(HTMLAttributes),
            ['a', { href: node.textContent }, 0],
        ];
    },
});
export const BrandGuidelines = Node.create({
    name: LIST_EXT_NAME,
    group: 'block',
    content: `${ITEM_EXT_NAME}+`,
    atom: true,
    draggable: true,
    addOptions() {
        return {
            tagName: 'mb-brand-guidelines',
        };
    },
    addCommands() {
        return {
            addBrandGuidelines: () => ({ commands }) => {
                return commands.insertContent({
                    type: this.name,
                    content: [
                        {
                            type: ITEM_EXT_NAME,
                        },
                    ],
                });
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: this.options.tagName,
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return [this.options.tagName, mergeAttributes(HTMLAttributes), 0];
    },
});
//# sourceMappingURL=brand-guidelines.js.map